import { render, staticRenderFns } from "./PianificazioneTreno_old.vue?vue&type=template&id=b65218d8&"
import script from "./PianificazioneTreno_old.vue?vue&type=script&lang=js&"
export * from "./PianificazioneTreno_old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports